module.exports = __webpack_public_path__ + "img/team_empty.bc9fa4a0.png";